import React from "react";

import { TxStatus } from "../types";

export interface TxIconProps {
  status: TxStatus;
  className?: string;
}

export function SupTxIcon({ status, className }: TxIconProps) {
  switch (status) {
    case "confirmed":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" className={className}>
          <path d="M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" fill="#24A167" />
          <path
            d="M16.375 6L7.625 14.75M4.75 11L8.5 14.75M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
            stroke="white"
            strokeWidth="0.5"
          />
        </svg>
      );
    case "processing":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" className={className}>
          <path d="M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" fill="#F5C043" />
          <path
            d="M4.125 11H6.625M7.875 11H10.375M11.625 11H14.125M15.375 11H17.875M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
            stroke="#404040"
            strokeWidth="0.5"
          />
        </svg>
      );
    case "stuck":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" className={className}>
          <path d="M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" fill="#E8684B" />
          <path
            d="M9.125 7.25V14.75M12.875 7.25V14.75M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
            stroke="white"
            strokeWidth="0.5"
          />
        </svg>
      );
    case "reverted":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 20 20" fill="none" className={className}>
          <path
            d="M6.07322 6.42678L9.65295 10.0065L6.07322 13.5862L6.42678 13.9398L10.0065 10.3601L13.5862 13.9398L13.9398 13.5862L10.3601 10.0065L13.9398 6.42678L13.5862 6.07322L10.0065 9.65295L6.42678 6.07322L6.07322 6.42678ZM19.75 10C19.75 15.3848 15.3848 19.75 10 19.75C4.61522 19.75 0.25 15.3848 0.25 10C0.25 4.61522 4.61522 0.25 10 0.25C15.3848 0.25 19.75 4.61522 19.75 10Z"
            fill="#BA002A"
            stroke="white"
            strokeWidth="0.5"
          />
        </svg>
      );
    default:
      return null;
  }
}
